import { getEnv } from '~/utils/env';

export function getParseURL(businessUnit: string): string {
  return getEnv(`PARSE_URL_${businessUnit}`);
}

export function getParseAppId(businessUnit: string): string {
  return getEnv(`PARSE_APP_ID_${businessUnit}`);
}

export function getParseRestApiKey(businessUnit: string): string {
  return getEnv(`PARSE_REST_API_KEY_${businessUnit}`);
}

export function getWebMissionApplicationUsername(businessUnit: string): string {
  return getEnv(`WEB_MISSION_APPLICATION_USER_${businessUnit}`);
}

export function getWebMissionApplicationPassword(businessUnit: string): string {
  return getEnv(`WEB_MISSION_APPLICATION_PASSWORD_${businessUnit}`);
}
